import React from 'react'
import styled from 'styled-components'
import { Button, ButtonSize, ButtonThemeType } from '../../components/Button'
import { SCREEN_SIZE, STYLES } from '../../static/style'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import { showSchoolLoginModal } from '../../states/schools/actions'
import { useCurrentUser } from '../../components/User/useCurrentUser'
import { useAppSelector } from '../../hooks/useAppSelector'
import { RootState } from '../../states/store'
import { hideFloatingAuthPanel } from '../../states/panels/actions'

const StyledFloatingBottomAuthPanel = styled.div`
  position: fixed;
  bottom: 0;
  transform: translateY(100%);
  transition: 1s;
  padding: 0.4rem 1.8rem;
  border-radius: 2rem 2rem 0 0;
  background-color: ${STYLES.COLOR_WHITE};
  width: 100%;
  min-height: 20%;
  display: flex;
  align-items: center;
  box-shadow: 0 0 0.5rem #999;
  ${({ isShowPanel }: { isShowPanel?: boolean }) =>
    isShowPanel &&
    `
    transform: translateY(0);
  `}
`

const FloatingBottomAuthPanelContent = styled.div`
  width: 80%;
  min-width: 18rem;
  margin: 0 auto;
  text-align: center;
  ${SCREEN_SIZE.SM} {
    width: 70%;
  }
`

const FloatingBottomAuthPanelActions = styled.div``

const StyledLoginButton = styled(Button).attrs({
  size: ButtonSize.MD,
  inline: false,
  theme: ButtonThemeType.PRIMARY,
})`
  width: 100%;
`

const StyledContinueButton = styled(Button).attrs({
  size: ButtonSize.SM,
  inline: false,
  theme: ButtonThemeType.NORMAL,
})`
  width: 100%;
  && {
    margin-top: 0.5rem;
    border: 0;
    background-color: ${STYLES.COLOR_WHITE};
    background-image: none;
    &:hover {
      color: ${STYLES.PRIMARY_COLOR};
    }
  }
`

const FeatureList = styled.div`
  padding-bottom: 0.6rem;
  text-align: left;
  font-size: ${STYLES.FONT_SIZE_LG};
`

const FeatureListItem = styled.div`
  font-size: ${STYLES.FONT_SIZE_MD};
  text-align: center;
`

const FloatingBottomAuthPanel = () => {
  const dispatch = useAppDispatch()
  const currentUser = useCurrentUser()
  const showFloatingAuthPanel = useAppSelector(
    ({ panels }: RootState) => panels.showFloatingAuthPanel
  )
  if (currentUser) {
    return null
  }
  return (
    <StyledFloatingBottomAuthPanel isShowPanel={showFloatingAuthPanel}>
      <FloatingBottomAuthPanelContent>
        <FeatureList>
          <FeatureListItem>
            View popular suburbs
            <br />& more school info
          </FeatureListItem>
        </FeatureList>
        <FloatingBottomAuthPanelActions>
          <StyledLoginButton
            label="Sign up for free"
            onClick={() => dispatch(showSchoolLoginModal())}
          >
            Sign up for free
          </StyledLoginButton>
          <StyledContinueButton
            label="Continue as Guest"
            onClick={() => {
              dispatch(hideFloatingAuthPanel())
            }}
          >
            Continue as Guest
          </StyledContinueButton>
        </FloatingBottomAuthPanelActions>
      </FloatingBottomAuthPanelContent>
    </StyledFloatingBottomAuthPanel>
  )
}

export default FloatingBottomAuthPanel
